import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'ca', ...(require('/builds/popsup/washoku-front-end/src/models/ca.ts').default) });
app.model({ namespace: 'landing', ...(require('/builds/popsup/washoku-front-end/src/models/landing.ts').default) });
app.model({ namespace: 'meta', ...(require('/builds/popsup/washoku-front-end/src/models/meta.ts').default) });
app.model({ namespace: 'od', ...(require('/builds/popsup/washoku-front-end/src/models/od.ts').default) });
app.model({ namespace: 'translation', ...(require('/builds/popsup/washoku-front-end/src/models/translation.ts').default) });
app.model({ namespace: 'user', ...(require('/builds/popsup/washoku-front-end/src/models/user.ts').default) });
app.model({ namespace: 'util', ...(require('/builds/popsup/washoku-front-end/src/models/util.ts').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
